export const QUICK_LINKS = [
  {
    name: 'Programs',
    path: '/programs',
  },
  {
    name: 'Add-Ons',
    path: '/add-ons',
  },
  {
    name: 'Case Studies',
    path: '/case-study',
  },
  {
    name: 'Events',
    path: '/events',
  },
  {
    name: 'Contact Us',
    path: '/contact-us',
  },
  {
    name: 'Press Release',
    path: '/press-release',
  },
];
export const OUR_SERVICES = [
  { href: '/csbg', name: 'CSBG' },
  { href: '/liheap', name: 'LIHEAP' },
  { href: '/head-start', name: 'Head Start' },
  { href: '/transportation', name: 'Transportation' },
  { href: '/victim-support-services', name: 'Victim Support Services' },
  { href: '/nutrition', name: 'Nutrition' },
  { href: '/weatherization', name: 'Weatherization' },
  { href: '/case-management', name: 'Case Management' },
  { href: '/youth-programs', name: 'Youth Programs' },
  { href: '/housing-assistance', name: 'Housing Assistance' },
].slice(0, 5);
